import React from "react";
import Gallery from "../gallery";
import styles from "./Content.module.scss";
import useGetCertificates from "./useGetCertificates";

const Content = () => {
  const { scope, certificate } = useGetCertificates();

  return (
    <section className={styles.wrap}>
      <div className={styles.imgWrap}>
        <div className={styles.pageTitle}>About Us</div>
        <div className={styles.pageDescription}>
          HopTechnic® was originally founded in 2010 by Virgil Gamache Farms
          (VGF) as the internal quality control lab for Amarillo® brand hops. By
          2017, the quality control program was extended to licensed Amarillo®
          growers in Idaho, Oregon, Washington and Germany. Today, HopTechnic®
          continues to provide quality control support for all the hops grown by
          VGF, including Amarillo® and Sonnet®, through a unique harvest
          monitoring program which focuses on aroma and flavor through thiol
          intensity analysis on cutting edge instrumentation. HopTechnic® offers
          standard testing services for the beer and hop industry, but also
          offers its more advanced capabilities including hop lot
          fingerprinting, harvest timing analysis, beer biotransformation
          tracking and R&D capabilities to brewers and growers alike. Many of
          the tests offered by our lab are accredited by{" "}
          <a className={styles.link} href={certificate.publicURL} target="_blank" rel="noopener noreferrer">
            <b>A2LA</b>
          </a>
          . Check out our{" "}
          <a className={styles.link} href={scope.publicURL} target="_blank" rel="noopener noreferrer">
            <b>scope of accreditation</b>
          </a>{" "}
          for the full list of our accredited tests.
        </div>
        <Gallery />
      </div>
      <span className={styles.border} />
    </section>
  );
};
export default Content;
